import { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { MapContainer, TileLayer, Polygon, Polyline } from 'react-leaflet'
import Highcharts from 'highcharts'
import { Marker } from 'react-leaflet'
import more from 'highcharts/highcharts-more'

import fitDecoder from 'fit-decoder'
import { differenceInMilliseconds } from 'date-fns'

import {
  useRestricted,
  useListSessionsWS,
  useUser,
  useLang,
  useTrkptsWS,
  useSessionWS,
} from '../utils/hooks'
import ChangeView from '../components/ChangeView'
import SpeedChart from '../components/SpeedChart'
// import { useDb } from '../utils/hooks'

import {
  getSessionData,
  getSpeedData,
  getMapData,
  getChartData,
  checkTrkptIsInRange,
  getTrkptsFromStr,
  getStrFromTrkpts,
  setLogItem,
  getSpeedAndDistanceFromTrkpts,
} from '../assets/assets_functions.js'
import {
  TrySpan,
  FileInput,
  StyledA,
  StyledMapContainer,
} from '../components/StyledElements'
import { blueOptions } from '../assets/colors'
import { red } from '../components/MarkerIcons/MarkerIcons'
import { cloneDeep } from 'lodash'

import { langTry } from '../assets/langTry'
import FileImportDiag from '../components/FileImportDiag'

require('highcharts/modules/annotations')(Highcharts)

more(Highcharts)

const tzlookup = require('tz-lookup')

const ms_to_knts = 1.9438445

const Try = () => {
  const firstDiv = useRef(null)
  const speedTile = useRef(null)

  const params = useParams()

  // const { db } = useDb()
  const { user } = useUser()
  const { setListSessionsWS } = useListSessionsWS()
  const { trkptsWS, changeTrkptsWS } = useTrkptsWS() //
  const { sessionWS, changeSessionWS } = useSessionWS() //

  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langTry.fr : langTry.eng
  const navigateTo = useNavigate()

  const [exampleSessionId, setExampleSessionId] = useState(-1)
  const [step, setStep] = useState(0)
  const { restricted, toggleRestricted } = useRestricted()
  const [isLoading, setIsLoading] = useState(false)
  const [gpxFile, setGpxFile] = useState()
  const [fileOk, setFileOk] = useState({
    ok: true,
    fileName: '',
    nb: 0,
    time: 0,
    lat: 0,
    lng: 0,
    ele: 0,
    speed: 0,
  })
  const [fitFile, setFitFile] = useState()
  const [session, setSession] = useState(null)

  const [datas, setDatas] = useState({
    center: null,
    polygon: null,
    mapPath: null,
    maxSpeed: null,
    speedRanges: null,
    speedDistRanges: null,
    distance: { origin: null, distance: 0 },
  })
  const [hasExcludedPoints, setHasExcludedPoints] = useState(false)
  const [markers, setMarkers] = useState([])

  useEffect(() => {
    if (step === 1)
      window.scrollTo({
        top: params.origin !== 'try' ? 100 : 280,
        behavior: 'smooth',
      })
  }, [step])

  useEffect(() => {
    const callApiSessionExample = async () => {
      const exampleSessionId = process.env.REACT_APP_EXAMPLE_SESSION_ID
      const urlSession = '/api/sessionWS/getSessionExample'
      fetch(urlSession, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: exampleSessionId,
        }),
      })
        .then((responseSession) => {
          responseSession.json().then((session) => {
            changeSessionWS({
              ...session[0],
              _id: '-1',
              sessionId: '',
              fileName: choosenLang.sessionExample,
              sessionTitle: choosenLang.sessionExample,
            })
            const url = '/api/tzip/loadTZip'
            fetch(url, {
              method: 'post',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                sessionId: exampleSessionId,
              }),
            })
              .then((response) => {
                response.json().then((data) => {
                  // const temp_trkpts = getTrkptsFromStr(data[0].trkpts)
                  const temp_trkpts = getTrkptsFromStr(data)
                  changeTrkptsWS({
                    brut: temp_trkpts,
                    origin: 'example',
                  })
                  setFitFile(null)
                  document.getElementById('fit_choose').value = null
                  setGpxFile(null)
                  document.getElementById('gpx_choose').value = null
                  setStep(1)
                })
              })
              .catch((error) => {
                console.log(error)
              })
          })
        })
        .catch((error) => {
          console.log(error)
        })
    }
    if (exampleSessionId === -1) return
    callApiSessionExample()
  }, [exampleSessionId])

  useEffect(() => {
    if (!gpxFile) return
    let reader = new FileReader()
    let parser = new DOMParser()
    let trkpt_a = []
    let previousTime = ''
    let eleNotOk = 0
    let timeNotOk = 0
    let latNotOk = 0
    let lngNotOk = 0
    let speedNotOk = 0
    reader.readAsText(gpxFile)
    reader.onload = () => {
      const xmlDoc = parser.parseFromString(reader.result, 'text/xml')
      const trkpt_nodes = [...xmlDoc.getElementsByTagName('trkpt')]

      trkpt_nodes.forEach((node) => {
        let temp_lat = 0
        let temp_lng = 0
        let temp_ele = 0
        let temp_time = null
        let temp_speed = 0
        if (node.children[1] !== undefined) {
          temp_time = node.children[1].innerHTML
        } else {
          timeNotOk++
        }
        if (node.attributes.lat !== undefined) {
          temp_lat = Number(node.attributes.lat.nodeValue)
        } else {
          latNotOk++
        }
        if (node.attributes.lon !== undefined) {
          temp_lng = Number(node.attributes.lon.nodeValue)
        } else {
          lngNotOk++
        }
        if (node.children[0] !== undefined) {
          temp_ele = Number(node.children[0].innerHTML)
        } else {
          eleNotOk++
        }
        if (node.children[2] !== undefined) {
          temp_speed = Number(node.children[2].innerHTML)
        } else {
          speedNotOk++
        }
        if (temp_time !== null) {
          if (temp_time !== previousTime) {
            trkpt_a.push({
              lat: temp_lat,
              lng: temp_lng,
              ele: temp_ele,
              time: temp_time,
              timeU: new Date(temp_time).getTime(),
              speed: temp_speed * ms_to_knts,
              excluded: 0,
            })
            previousTime = node.children[1].innerHTML
          }
        }
      })
      const isOk =
        timeNotOk + latNotOk + lngNotOk + speedNotOk /* + eleNotOk  */ === 0
      if (isOk === true) {
        changeTrkptsWS({
          brut: trkpt_a,
          origin: 'gpx',
        })
        setFitFile(null)
        document.getElementById('fit_choose').value = null
        setExampleSessionId(-1)
        setStep(1)
      }
      setFileOk({
        ok: isOk,
        fileName: gpxFile.name,
        nb: trkpt_nodes.length,
        time: timeNotOk,
        lat: latNotOk,
        lng: lngNotOk,
        ele: eleNotOk,
        speed: speedNotOk,
      })
    }
  }, [gpxFile])

  useEffect(() => {
    if (!fitFile) return
    let trkpt_a = []
    let reader = new FileReader()
    reader.readAsArrayBuffer(fitFile)
    reader.onload = (e) => {
      const buffer = e.target.result
      const jsonRaw = fitDecoder.fit2json(buffer)
      const json = fitDecoder.parseRecords(jsonRaw)
      let eleNotOk = 0
      let timeNotOk = 0
      let latNotOk = 0
      let lngNotOk = 0
      let speedNotOk = 0
      let nbNodes = 0
      json.records.forEach((node) => {
        if (node.type === 'record') {
          let temp_lat = 0
          let temp_lng = 0
          let temp_ele = 0
          let temp_time = null
          let temp_speed = 0
          nbNodes++
          if (node.data.timestamp !== undefined) {
            temp_time = new Date(node.data.timestamp)
          } else {
            timeNotOk++
          }
          if (node.data.position_lat !== undefined) {
            temp_lat = Number(node.data.position_lat)
          } else {
            latNotOk++
          }
          if (node.data.position_long !== undefined) {
            temp_lng = Number(node.data.position_long)
          } else {
            lngNotOk++
          }
          if (node.data.altitude !== undefined) {
            temp_ele = Number(node.data.altitude)
          } else {
            eleNotOk++
          }
          if (node.data.speed !== undefined) {
            temp_speed = Number(node.data.speed)
          } else {
            speedNotOk++
          }
          trkpt_a.push({
            lat: temp_lat,
            lng: temp_lng,
            ele: temp_ele,
            time: temp_time,
            timeU: temp_time.getTime(),
            speed: temp_speed * ms_to_knts,
            excluded: 0,
          })
        }
      })

      const isOk =
        timeNotOk + latNotOk + lngNotOk + speedNotOk /* + eleNotOk  */ === 0
      if (isOk === true) {
        const distance =
          Math.round(
            Number(json.records[json.records.length - 5].data.distance / 100),
          ) / 10

        setDatas({ ...datas, distance: distance })
        changeTrkptsWS({ brut: trkpt_a, origin: 'fit' })
        setGpxFile(null)
        document.getElementById('gpx_choose').value = null
        setExampleSessionId(-1)
        setStep(1)
      }
      setFileOk({
        ok: isOk,
        fileName: fitFile.name,
        nb: nbNodes,
        time: timeNotOk,
        lat: latNotOk,
        lng: lngNotOk,
        ele: eleNotOk,
        speed: speedNotOk,
      })
    }
  }, [fitFile])

  useEffect(() => {
    if (trkptsWS.brut.length === 0) return
    const temp_trkpts = trkptsWS.brut

    const timeZone = tzlookup(temp_trkpts[0].lat, temp_trkpts[0].lng)
    const {
      center,
      restrictedCenter,
      polygon,
      restrictedPolygon,
      timeDomain,
      restrictedTimeDomain,
    } = getSessionData(temp_trkpts)

    const { chartOptions /*, maxSpeed */ } = getChartData(
      temp_trkpts,
      timeZone,
      restricted,
      'try',
      null,
    )

    const { speedRanges, speedDistRanges } = getSpeedData(
      temp_trkpts,
      restricted,
    )

    const { speed, speedTime, distance } = getSpeedAndDistanceFromTrkpts(
      temp_trkpts,
      restricted,
    )

    const { mapPath } = getMapData(temp_trkpts, restricted)

    let new_datas = {}
    switch (trkptsWS.origin) {
      case 'fit':
        new_datas = {
          ...datas,
          center: center,
          restrictedCenter: restrictedCenter,
          polygon: polygon,
          restrictedPolygon: restrictedPolygon,
          mapPath: mapPath,
          chartOptions: chartOptions,
          timeDomain: timeDomain,
          restrictedTimeDomain: restrictedTimeDomain,
          //maxSpeed: maxSpeed,
          speedRanges: speedRanges,
          speedDistRanges: speedDistRanges,
          distance: Math.round(distance / 100) / 10,
        }
        break
      case 'gpx':
      case 'example':
        new_datas = {
          center: center,
          restrictedCenter: restrictedCenter,
          polygon: polygon,
          restrictedPolygon: restrictedPolygon,
          mapPath: mapPath,
          chartOptions: chartOptions,
          timeDomain: timeDomain,
          restrictedTimeDomain: restrictedTimeDomain,
          //maxSpeed: maxSpeed,
          speedRanges: speedRanges,
          speedDistRanges: speedDistRanges,
          distance: Math.round(distance / 100) / 10,
        }
        break
      default:
    }
    //if (sessionWS !== null) console.log(sessionWS.sessionTitle)

    const temp_session = {
      sessionStart: new Date(new_datas.timeDomain[0]),
      restrictedStartSession: new Date(new_datas.restrictedTimeDomain[0]),
      restrictedSessionStartU: new Date(
        new_datas.restrictedTimeDomain[0],
      ).getTime(),
      restrictedSessionEndU:
        new Date(new_datas.restrictedTimeDomain[0]).getTime() +
        differenceInMilliseconds(timeDomain[1], timeDomain[0]),
      utcLocalInterval: 0,
      startLat: new_datas.mapPath.positions[0][0],
      startLng: new_datas.mapPath.positions[0][1],
      timeZone: timeZone,
      sessionMinLat: new_datas.polygon[3][0],
      sessionMaxLat: new_datas.polygon[0][0],
      sessionMinLng: new_datas.polygon[1][1],
      sessionMaxLng: new_datas.polygon[0][1],
      restrictedSessionMinLat: new_datas.restrictedPolygon[3][0],
      restrictedSessionMaxLat: new_datas.restrictedPolygon[0][0],
      restrictedSessionMinLng: new_datas.restrictedPolygon[1][1],
      restrictedSessionMaxLng: new_datas.restrictedPolygon[0][1],
      sessionTitle:
        trkptsWS.origin === 'fit'
          ? fitFile !== undefined
            ? fitFile.name
            : sessionWS.sessionTitle
          : trkptsWS.origin === 'gpx'
            ? gpxFile !== undefined
              ? gpxFile.name
              : sessionWS.sessionTitle
            : choosenLang.sessionExample,
      sessionDuration:
        differenceInMilliseconds(timeDomain[1], timeDomain[0]) / 1000,
      restrictedSessionDuration:
        differenceInMilliseconds(
          restrictedTimeDomain[1],
          restrictedTimeDomain[0],
        ) / 1000,
      fileName:
        trkptsWS.origin === 'fit'
          ? fitFile !== undefined
            ? fitFile.name
            : sessionWS.sessionTitle
          : trkptsWS.origin === 'gpx'
            ? gpxFile !== undefined
              ? gpxFile.name
              : sessionWS.sessionTitle
            : choosenLang.sessionExample,
      meteoStationId: '',
      userId: user.userId,
      sessionId: '',
      maxSpeed: Math.round(speed * 10) / 10,
      maxSpeedTime: speedTime,
      distance: Math.round(distance / 100) / 10,
    }

    setDatas(new_datas)
    setSession(temp_session)
    setLogItem({
      log: {
        date: new Date(),
        what: trkptsWS.origin,
        useType: params.origin,
        polygon: new_datas.polygon,
        nbTracks: trkptsWS.brut.length,
      },
    })
  }, [trkptsWS, restricted])

  useEffect(() => {
    if (!session) return
    if (session.sessionId === '') return
    setIsLoading(true)

    // const base64Str = getStrFromTrkpts(trkptsWS.brut)
    const toBeCompressedStr = getStrFromTrkpts(trkptsWS.brut)
    const url = '/api/tzip/createTZip'
    const my_data = JSON.stringify({
      // trkpts: base64Str,
      trkpts: toBeCompressedStr,
      sessionId: session.sessionId,
    })
    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: my_data,
    })
      .then((response) => {
        response.json().then((data) => {
          console.log('ok')
          setIsLoading(false)
          setListSessionsWS({ type: 'RESET_SESSIONS' })
          navigateTo('/sessions/')
        })
      })
      .catch((error) => {
        console.log('Error adding tzip', error)
      })
  }, [session])

  const handle_gpx_file = (event) => {
    const selected_gpx_file = event.target.files[0]
    setGpxFile(selected_gpx_file)
    setStep(0)
  }

  const handle_fit_file = (event) => {
    const selected_fit_file = event.target.files[0]
    setFitFile(selected_fit_file)
    setStep(0)
  }

  const handleUpdateMapMarkers = (values) => {
    setIsLoading(true)
    if (values.length > 0) {
      let markers = []
      const temp_trkpts = trkptsWS.brut
      temp_trkpts.forEach((trkpt) => {
        let i = 0
        let flag = false
        while (i < values.length && !flag) {
          flag = checkTrkptIsInRange(values[i], trkpt) && trkpt.excluded === 0
          i++
        }

        if (flag) {
          markers.push(<Marker position={[trkpt.lat, trkpt.lng]} icon={red} />)
        }
      })
      setMarkers(markers)
    } else {
      setMarkers([])
    }
    setIsLoading(false)
  }

  const handleApplySelection = (values) => {
    const temp_trkpts = cloneDeep(trkptsWS.brut)
    temp_trkpts.forEach((trkpt) => {
      let i = 0
      let flag = false
      while (i < values.length && !flag) {
        flag = checkTrkptIsInRange(values[i], trkpt)
        i++
      }

      if (flag) {
        trkpt.excluded = 1
      }
    })
    changeTrkptsWS({
      ...trkptsWS,
      brut: temp_trkpts,
    })
    setHasExcludedPoints(true)
    if (!restricted) toggleRestricted()
    setMarkers([])
  }

  const handleSeeStats = () => {
    /*if (session._id)*/ changeSessionWS(session)
    navigateTo('/oneSessionStats/')
  }

  const handleCancel = () => {
    const temp_trkpts = cloneDeep(trkptsWS.brut)
    temp_trkpts.forEach((trkpt) => (trkpt.excluded = 0))
    setHasExcludedPoints(false)
    changeTrkptsWS({
      ...trkptsWS,
      brut: temp_trkpts,
    })
    setMarkers([])
  }

  const handleSave = () => {
    const url = '/api/sessionWS/createSessionWS'
    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(session),
    })
      .then((response) => {
        response.json().then((data) => {
          const temp_session = { ...session, sessionId: data._id }
          setSession(temp_session)
        })
      })
      .catch((error) => {
        console.log('Error adding session', error)
      })
  }

  return (
    <div>
      <section className="section" ref={firstDiv}>
        <h1 className="title is-4 has-text-info-dark">
          {params.origin === 'try' ? choosenLang.test : choosenLang.add}
        </h1>
        <div className="grid">
          <div className="cell">
            <div className="notification is-white ">
              <form encType="multipart/form-data">
                <TrySpan>{choosenLang.open1}</TrySpan>
                <FileInput
                  id="gpx_choose"
                  type="file"
                  onChange={handle_gpx_file}
                  accept=".gpx"
                />
                <StyledA
                  to="#"
                  onClick={(e) => {
                    document.getElementById('gpx_choose').click()
                    e.preventDefault()
                  }}
                >
                  {choosenLang.opengpx}
                </StyledA>
                <span>{choosenLang.open2}</span>
                <FileInput
                  id="fit_choose"
                  type="file"
                  onChange={handle_fit_file}
                  accept=".fit"
                />
                <StyledA
                  to="#"
                  onClick={(e) => {
                    document.getElementById('fit_choose').click()
                    e.preventDefault()
                  }}
                >
                  {choosenLang.openfit}
                </StyledA>
                {params.origin === 'try' && (
                  <>
                    <br />
                    <br />
                    <TrySpan>{choosenLang.open3}</TrySpan>
                    <StyledA
                      to="#"
                      onClick={(e) => {
                        setExampleSessionId(30)
                        e.preventDefault()
                      }}
                    >
                      {choosenLang.openexample}
                    </StyledA>{' '}
                    <TrySpan>{choosenLang.open4}</TrySpan>
                  </>
                )}
              </form>
            </div>
            {fileOk.ok === true && step >= 1 && (
              <div className="notification is-warning ">
                {choosenLang.convert}
              </div>
            )}
          </div>
          {fileOk.ok === true && datas.center !== null && step >= 1 && (
            <div className="cell is-col-span-5">
              <div className="is-white box">
                <StyledMapContainer>
                  <MapContainer
                    scrollWheelZoom={true}
                    maxZoom={18}
                    zoomOffset={-1}
                  >
                    <ChangeView
                      center={
                        restricted ? datas.restrictedCenter : datas.center
                      }
                      origin={'try'}
                      map_bounds={
                        restricted ? datas.restrictedPolygon : datas.polygon
                      }
                      map_path={datas.mapPath.positions}
                    />
                    <TileLayer
                      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      zIndex="0"
                    />

                    {!datas.mapPath && (
                      <Polygon
                        pathOptions={blueOptions}
                        positions={
                          restricted ? datas.restrictedPolygon : datas.polygon
                        }
                      />
                    )}
                    <Polyline
                      pathOptions={blueOptions}
                      positions={datas.mapPath.positions}
                    />
                    {markers.length > 0 && markers}
                  </MapContainer>
                </StyledMapContainer>
              </div>
            </div>
          )}
        </div>
        {fileOk.ok === false && <FileImportDiag diag={fileOk} />}

        {fileOk.ok === true && datas.center !== null && step >= 1 && (
          <>
            <div className="grid">
              <div className="cell">
                <div className="notification is-white">
                  <p>{choosenLang.delete1}</p>
                </div>
              </div>

              <div className="cell is-col-span-5" ref={speedTile}>
                <div className="is-white box">
                  <div className="block">
                    <SpeedChart
                      origin={params.origin}
                      loading={isLoading}
                      options={datas.chartOptions}
                      timeDomain={
                        restricted
                          ? datas.restrictedTimeDomain
                          : datas.timeDomain
                      }
                      handleUpdateMapMarkers={handleUpdateMapMarkers}
                      handleApplySelection={handleApplySelection}
                      maxSpeed={datas.maxSpeed}
                      handleSeeStats={handleSeeStats}
                      handleCancel={handleCancel}
                      handleSave={handleSave}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid">
              <div className="cell">
                <div className="notification is-warning">
                  <p>{choosenLang.delete2}</p>
                  <p>
                    {choosenLang.delete3}
                    <span className="tag is-primary is-small is-light">
                      {'  '}
                      {params.origin === 'try'
                        ? choosenLang.see
                        : choosenLang.save}
                    </span>
                  </p>
                </div>
              </div>
              <div className="cell  is-col-span-5">
                <div className="notification is-white">
                  <div className="columns">
                    <div className="column">
                      {choosenLang.delete4}
                      <span className="tag is-info is-small is-light">
                        {'  '}+{' '}
                      </span>
                      {choosenLang.delete5}
                    </div>
                    <div className="column">
                      {choosenLang.delete6}
                      <span className="tag is-info is-small is-light">
                        {'  '}-{' '}
                      </span>
                      {choosenLang.delete7}
                    </div>
                    <div className="column">
                      {choosenLang.delete8 + ' '}
                      <span className="tag is-primary is-small is-light">
                        {choosenLang.apply}
                      </span>
                      {choosenLang.delete9}
                    </div>
                    <div className="column">
                      {choosenLang.delete10}
                      <span className="tag is-primary is-small is-light">
                        {choosenLang.cancelAll}
                      </span>
                      .
                    </div>
                    <div className="column">
                      {choosenLang.delete11}
                      <span className="tag is-primary is-small is-light">
                        {'  '}
                        {params.origin === 'try'
                          ? choosenLang.see
                          : choosenLang.save}
                      </span>
                      .
                    </div>{' '}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </section>
    </div>
  )
}

export default Try
